import React from "react";

const Services = () => {
  return (
    <div style={{ backgroundColor: "#212529" }}>
      <h1 className="pt-4 py-5 text-center" style={{ color: "#ffa500" }}>
        Services
      </h1>

      <div className="container">
        <div className="row">
          <div className="col-sm">
            <h2 className="text-center">
              <i className="fas fa-fill-drip text-white"></i>
            </h2>
            <h4 style={{ color: "#ffa500" }} className="text-center ">Web Design</h4>
            <br />
            <img
              className="w-75"
              src="https://i.ibb.co/7CxbksN/124-1247775-web-development-website-design-web-development-web-design-removebg-preview.png"
              alt=""
            />
          </div>
          <div className="col-sm">
            <h2 className="text-center">
              <i className="fab fa-artstation text-white"></i>
            </h2>
            <h4 style={{ color: "#ffa500" }} className="text-center "> Ui Design</h4>
            <br />
            <img
              className="w-75"
              src="https://i.ibb.co/1L2bbVL/219-2195635-transparent-web-development-png-ui-design-png-download-removebg-preview.png"
              alt=""
            />
          </div>
          <div className="col-sm">
            <h2 className="text-center">
              <i className="fab fa-react text-white"></i>
            </h2>
            <h4 style={{ color: "#ffa500" }} className="text-center ">Front End</h4>
            <br />
            <img
              className="w-75"
              src="https://i.ibb.co/mHpCmG5/2-2-web-design-png-image-removebg-preview.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
